export default __webpack_public_path__ + "static/media/anonymous.1141569b.svg";